import { render, staticRenderFns } from "./ScanReturnLabel.vue?vue&type=template&id=0477472a&"
import script from "./ScanReturnLabel.vue?vue&type=script&lang=js&"
export * from "./ScanReturnLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports